import { RouteObject } from 'react-router-dom';
import { lazy } from 'react';

const HomePage = lazy(() => import('../pages/home/page'));
const RatingPage = lazy(() => import('../pages/rating/page'));
const ProvidersPage = lazy(() => import('../pages/providers/page'));
const NotFound = lazy(() => import('../pages/NotFound'));

const routes: RouteObject[] = [
  {
    path: '/',
    element: <HomePage />,
  },
  {
    path: '/rating',
    element: <RatingPage />,
  },
  {
    path: '/providers',
    element: <ProvidersPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;